var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { formatMoney, formatNumber } from '../../common/helpers';
import { UserRoles } from '../../domain/Models';
import PrizeDistributorService from '../../domain/PrizeDistributorService';
import WonPrizeService from '../../domain/WonPrizeService';
import gs from '../../styles/style';
import { UserContext } from '../Auth/UserProvider';
import { Pager, SearchInput, TableLoader, useDataframe } from '../Common/Dataframe';
import DateTime from '../Common/DateTime';
import TicketNumber from '../Tickets/TicketNumber';
var FontAwesomeIcon = require('@fortawesome/react-fontawesome').FontAwesomeIcon;
export var Tabs;
(function (Tabs) {
    Tabs["Distributors"] = "distributors";
    Tabs["Undistributed"] = "undistributed";
})(Tabs || (Tabs = {}));
var PrizeDistributorOverview = function (_a) {
    var _b = _a.tab, tab = _b === void 0 ? Tabs.Distributors : _b;
    var t = useTranslation()[0];
    var user = useContext(UserContext).user;
    var dataframe = useDataframe(PrizeDistributorService.getPrizeDistributors, {
        perPage: 10
    });
    return React.createElement(React.Fragment, null,
        React.createElement("div", { className: gs('section-header') },
            React.createElement("h1", { className: gs('section-title') }, t('prize_distribution'))),
        user.role !== UserRoles.Finance && React.createElement("ul", { className: gs('nav', 'nav-tabs', 'mb-4') },
            React.createElement("li", { className: gs('nav-item') },
                React.createElement(Link, { to: "/prize-distributors", className: gs('nav-link', { active: tab == Tabs.Distributors }) }, t('distributors'))),
            React.createElement("li", { className: gs('nav-item') },
                React.createElement(Link, { to: "/prize-distributors/undistributed", className: gs('nav-link', { active: tab == Tabs.Undistributed }) }, t('undistributed')))),
        tab == Tabs.Distributors && React.createElement(PrizeDistributorsTable, null),
        tab == Tabs.Undistributed && React.createElement(UndistributedWonPrizes, null));
};
var PrizeDistributorsTable = function () {
    var t = useTranslation()[0];
    var dataframe = useDataframe(PrizeDistributorService.getPrizeDistributors, {
        perPage: 10
    });
    return React.createElement(React.Fragment, null,
        React.createElement("table", { className: gs('table-overview', 'mt-4', { loading: dataframe.isLoading() }) },
            React.createElement("thead", null,
                React.createElement("tr", null,
                    React.createElement("th", { style: { width: '40%' } }, t('prize_distributor')),
                    React.createElement("th", { style: { width: '20%' } }, t('distributable_prizes')),
                    React.createElement("th", null, t('last_distributed_at')))),
            React.createElement("tbody", null,
                React.createElement(TableLoader, { dataframe: dataframe, columns: 3 }),
                dataframe.getData().map(function (prizeDistributor) { return React.createElement("tr", { key: prizeDistributor.id },
                    React.createElement("td", null,
                        React.createElement(Link, { to: "/prize-distributors/".concat(prizeDistributor.id) },
                            React.createElement("strong", null, prizeDistributor.title))),
                    React.createElement("td", null, formatNumber(prizeDistributor.distributable_count)),
                    React.createElement("td", null,
                        React.createElement(DateTime, { date: prizeDistributor.last_distributed_at }))); }))),
        dataframe.getPageCount() > 1 && React.createElement("div", { className: gs('mt-4') },
            React.createElement(Pager, { dataframe: dataframe })));
};
var UndistributedWonPrizes = function () {
    var t = useTranslation()[0];
    var dataframe = useDataframe(function (config) {
        return WonPrizeService.getWonPrizes(__assign(__assign({}, config), { params: __assign(__assign({}, config.params), { distributed: false }) }));
    }, {
        perPage: 10
    });
    return React.createElement(React.Fragment, null,
        React.createElement("div", { className: gs('w-50') },
            React.createElement(SearchInput, { dataframe: dataframe })),
        React.createElement("table", { className: gs('table-overview', 'mt-4', { loading: dataframe.isLoading() }) },
            React.createElement("thead", null,
                React.createElement("tr", null,
                    React.createElement("th", { style: { width: '12.5%' } }, t('draw')),
                    React.createElement("th", { style: { width: '22.5%' } }, t('ticket')),
                    React.createElement("th", { style: { width: '35%' } }, t('customer')),
                    React.createElement("th", { style: { width: '15%' } }, t('prize')),
                    React.createElement("th", { style: { width: '15%' } },
                        " ",
                        t('value')))),
            React.createElement("tbody", null,
                React.createElement(TableLoader, { dataframe: dataframe, columns: 5 }),
                dataframe.getData().map(function (wonPrize) { return React.createElement("tr", { key: wonPrize.id },
                    React.createElement("td", null,
                        React.createElement(Link, { to: "/draws/".concat(wonPrize.participation.draw.id) }, wonPrize.participation.draw.title)),
                    React.createElement("td", null,
                        React.createElement(Link, { to: "/tickets/".concat(wonPrize.participation.ticket.id) },
                            React.createElement(TicketNumber, { number: wonPrize.participation.ticket.number }))),
                    React.createElement("td", null,
                        wonPrize.participation.ticket.customer.name,
                        ' ',
                        wonPrize.participation.ticket.customer.verified_at && React.createElement("small", { className: gs('text-success') },
                            React.createElement(FontAwesomeIcon, { icon: "check" })),
                        wonPrize.participation.ticket.customer.rsu && React.createElement("small", { className: gs('text-muted') },
                            ' ',
                            " / ",
                            ' ',
                            wonPrize.participation.ticket.customer.rsu.title),
                        wonPrize.participation.ticket.customer.external_id && React.createElement("small", { className: gs('text-muted') },
                            ' ',
                            " / ",
                            ' ',
                            React.createElement("code", null, wonPrize.participation.ticket.customer.external_id))),
                    React.createElement("td", null, wonPrize.prize.title),
                    React.createElement("td", null, formatMoney(wonPrize.amount))); }))),
        dataframe.getPageCount() > 1 && React.createElement("div", { className: gs('mt-4') },
            React.createElement(Pager, { dataframe: dataframe })));
};
export default PrizeDistributorOverview;
